import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ compact = false }) => {
  const { language, changeLanguage } = useTranslation();

  return (
    <div className="flex items-center gap-1.5 shrink-0">
      <Globe className="w-4 h-4 text-gray-600 shrink-0" />
      <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className={`border border-gray-300 rounded-md bg-white text-gray-700 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent cursor-pointer shrink-0 ${
          compact ? 'px-2 py-1 text-xs max-w-[5.5rem]' : 'px-2.5 py-1.5 text-sm max-w-[7.5rem]'
        }`}
      >
        <option value="en">English</option>
        <option value="nl">Nederlands</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;

